var _wrapNativeSuper = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _classCallCheck = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/babbs/Desktop/isolines/node_modules/@babel/runtime/helpers/inherits");

/*!
 <lui-desktoplayer-theme>, <lui-contextchromelayer-theme>, <lui-canvaslayer-theme>, <lui-contentchromelayer-theme>, <lui-brandmembranelayer-theme>
 Version: 1.1.4

 Copyright (C) 2019 HERE Global B.V. and its affiliate(s).
 All rights reserved.

 This software and other materials contain proprietary information
 controlled by HERE and are protected by applicable copyright legislation.
 Any use and utilization of this software and other materials and
 disclosure to any third parties is conditional upon having a separate
 agreement with HERE for the access, use, utilization or disclosure of this
 software. In the absence of such agreement, the use of the software is not
 allowed.
*/
(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if (typeof exports === 'object') exports["lui-here-layer-theme"] = factory();else root["lui"] = root["lui"] || {}, root["lui"]["lui-here-layer-theme"] = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "/assets/";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 149);
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      149:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        Object.defineProperty(__webpack_exports__, "__esModule", {
          value: true
        });
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_desktoplayer_theme__ = __webpack_require__(150);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_1_lui_desktoplayer_theme_global_scss__ = __webpack_require__(151);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_1_lui_desktoplayer_theme_global_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lui_desktoplayer_theme_global_scss__);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_2__lui_contextchromelayer_theme__ = __webpack_require__(152);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_3_lui_contextchromelayer_theme_global_scss__ = __webpack_require__(153);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_3_lui_contextchromelayer_theme_global_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lui_contextchromelayer_theme_global_scss__);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_4__lui_canvaslayer_theme__ = __webpack_require__(154);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_5_lui_canvaslayer_theme_global_scss__ = __webpack_require__(155);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_5_lui_canvaslayer_theme_global_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lui_canvaslayer_theme_global_scss__);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_6__lui_contentchromelayer_theme__ = __webpack_require__(156);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_7_lui_contentchromelayer_theme_global_scss__ = __webpack_require__(157);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_7_lui_contentchromelayer_theme_global_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lui_contentchromelayer_theme_global_scss__);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_8__lui_brandmembranelayer_theme__ = __webpack_require__(158);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_9_lui_brandmembranelayer_theme_global_scss__ = __webpack_require__(159);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_9_lui_brandmembranelayer_theme_global_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lui_brandmembranelayer_theme_global_scss__);
        /**
         * Copyright (C) 2018 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */


        window.lui.registerComponent(__WEBPACK_IMPORTED_MODULE_0__lui_desktoplayer_theme__["a"
        /* default */
        ], __WEBPACK_IMPORTED_MODULE_1_lui_desktoplayer_theme_global_scss___default.a);
        window.lui.registerComponent(__WEBPACK_IMPORTED_MODULE_2__lui_contextchromelayer_theme__["a"
        /* default */
        ], __WEBPACK_IMPORTED_MODULE_3_lui_contextchromelayer_theme_global_scss___default.a);
        window.lui.registerComponent(__WEBPACK_IMPORTED_MODULE_4__lui_canvaslayer_theme__["a"
        /* default */
        ], __WEBPACK_IMPORTED_MODULE_5_lui_canvaslayer_theme_global_scss___default.a);
        window.lui.registerComponent(__WEBPACK_IMPORTED_MODULE_6__lui_contentchromelayer_theme__["a"
        /* default */
        ], __WEBPACK_IMPORTED_MODULE_7_lui_contentchromelayer_theme_global_scss___default.a);
        window.lui.registerComponent(__WEBPACK_IMPORTED_MODULE_8__lui_brandmembranelayer_theme__["a"
        /* default */
        ], __WEBPACK_IMPORTED_MODULE_9_lui_brandmembranelayer_theme_global_scss___default.a);
        /***/
      },

      /***/
      150:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_base_lui_theme__ = __webpack_require__(9);
        /**
         * Copyright (C) 2018 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */


        var LuiDesktoplayerTheme =
        /*#__PURE__*/
        function (_WEBPACK_IMPORTED_MO) {
          _inherits(LuiDesktoplayerTheme, _WEBPACK_IMPORTED_MO);

          function LuiDesktoplayerTheme() {
            _classCallCheck(this, LuiDesktoplayerTheme);

            return _possibleConstructorReturn(this, _getPrototypeOf(LuiDesktoplayerTheme).apply(this, arguments));
          }

          _createClass(LuiDesktoplayerTheme, null, [{
            key: "is",
            get: function get() {
              return 'lui-desktoplayer-theme';
            }
          }]);

          return LuiDesktoplayerTheme;
        }(__WEBPACK_IMPORTED_MODULE_0__lui_base_lui_theme__["a"
        /* default */
        ]);
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiDesktoplayerTheme;
        /***/
      },

      /***/
      151:
      /***/
      function _(module, exports) {
        module.exports = "lui-desktoplayer-theme{--lui-font-family:\"FiraGO\",\"Fira Sans\",sans-serif;--lui-code-font-family:\"Fira Mono\",monospace;--lui-bold:600;--lui-medium:500;--lui-normal:400;--lui-light:300;--lui-background-color:#0f1621;--lui-secondary-background-color:#272d37;--lui-tertiary-background-color:#1b222c;--lui-headline-text-color:#fff;--lui-text-color:#fff;--lui-subdued-text-color:hsla(0,0%,100%,.6);--lui-knob-color:#fff;--lui-accent-background-color:rgba(45,213,201,.15);--lui-accent-color:#2dd5c9;--lui-accent-text-color:rgba(15,22,33,.8);--lui-neutral-color:hsla(0,0%,100%,.4);--lui-field-background-color:hsla(0,0%,100%,.1);--lui-field-border-color:rgba(15,22,33,.6);--lui-field-text-color:#fff;--lui-field-placeholder-color:rgba(15,22,33,.8);--lui-field-selection-background-color:rgba(45,213,201,.2);--lui-field-selection-text-color:inherit;--lui-field-caret-color:#2dd5c9;--lui-focus-ring-width:3px;--lui-focus-ring-color:rgba(45,213,201,.2);--lui-logo-color:#fff;--lui-logo-missing-piece-color:#2dd5c9;--lui-tooltip-background-color:#fff;--lui-tooltip-text-color:#0f1621;--lui-overlay-background-color:#1b222c;--lui-overlay-text-color:hsla(0,0%,100%,.8);--lui-decoration-text-color:#fff;--lui-darkaqua:#00b6b2;--lui-lightblue:#52a3db;--lui-darkblue:#2c48a1;--lui-pink:#c53680;--lui-orange:#ed610e;--lui-purple:#673a93;--lui-darkgreen:#70943c;--lui-positive-color:#00bd7d;--lui-significant-color:#ffbd09;--lui-negative-color:#cf001a;-webkit-font-smoothing:antialiased}lui-desktoplayer-theme .lui-selected{--lui-overlay-text-color:#fff}lui-desktoplayer-theme :focus{--lui-overlay-background-color:#3f454d}@media (hover:hover){lui-desktoplayer-theme .lui-interactive:hover{--lui-accent-color:#76e3dc;--lui-accent-text-color:rgba(15,22,33,.8);--lui-subdued-text-color:#fff;--lui-neutral-color:hsla(0,0%,100%,.7)}lui-desktoplayer-theme .lui-interactive:active{--lui-accent-color:#00b6b2;--lui-accent-text-color:rgba(15,22,33,.8);--lui-subdued-text-color:hsla(0,0%,100%,.1);--lui-neutral-color:hsla(0,0%,100%,.8)}lui-desktoplayer-theme .lui-interactive:focus-visible{box-shadow:0 0 0 2px rgba(0,204,195,.2)}}lui-desktoplayer-theme .lui-focus{--lui-field-background-color:hsla(0,0%,100%,.05);--lui-field-text-color:#fff}lui-desktoplayer-theme .lui-positive{--lui-accent-background-color:rgba(0,189,125,.15);--lui-focus-ring-color:rgba(0,189,125,.21);--lui-text-color:#2fd79f;--lui-accent-color:#00bd7d;--lui-overlay-text-color:#00bd7d;--lui-accent-text-color:rgba(15,22,33,.8);--lui-neutral-color:#2fd79f;--lui-field-background-color:#2fd79f;--lui-field-border-color:rgba(15,22,33,.4);--lui-field-text-color:#fff;--lui-field-caret-color:#0f1621;--lui-field-selection-background-color:hsla(0,0%,100%,.4)}lui-desktoplayer-theme .lui-positive.lui-focus{--lui-field-background-color:#00bd7d;--lui-field-text-color:#fff}lui-desktoplayer-theme .lui-significant{--lui-accent-background-color:rgba(255,189,9,.15);--lui-focus-ring-color:rgba(255,189,9,.35);--lui-text-color:#ffd01b;--lui-accent-color:#ffbd09;--lui-overlay-text-color:#ffbd09;--lui-accent-text-color:rgba(15,22,33,.8);--lui-neutral-color:#ffd01b;--lui-field-background-color:#ffd01b;--lui-field-border-color:rgba(15,22,33,.4);--lui-field-text-color:#fff;--lui-field-caret-color:#0f1621;--lui-field-selection-background-color:hsla(0,0%,100%,.4)}lui-desktoplayer-theme .lui-significant.lui-focus{--lui-field-background-color:#ffbd09;--lui-field-text-color:#fff}lui-desktoplayer-theme .lui-negative{--lui-accent-background-color:rgba(207,0,26,.15);--lui-focus-ring-color:rgba(207,0,26,.15);--lui-text-color:#d35566;--lui-accent-color:#cf001a;--lui-overlay-text-color:#cf001a;--lui-accent-text-color:rgba(15,22,33,.8);--lui-neutral-color:#d35566;--lui-field-background-color:#d35566;--lui-field-border-color:rgba(15,22,33,.4);--lui-field-text-color:#fff;--lui-field-caret-color:#0f1621;--lui-field-selection-background-color:hsla(0,0%,100%,.4)}lui-desktoplayer-theme .lui-negative.lui-focus{--lui-field-background-color:#cf001a;--lui-field-text-color:#fff}@media (hover:hover){lui-desktoplayer-theme .lui-positive.lui-interactive:hover,lui-desktoplayer-theme :host(.lui-positive) .lui-interactive:hover{--lui-accent-color:#2fd79f;--lui-neutral-color:#00bd7d;--lui-accent-text-color:rgba(15,22,33,.8)}lui-desktoplayer-theme .lui-positive.lui-interactive:active,lui-desktoplayer-theme :host(.lui-positive) .lui-interactive:active{--lui-accent-color:#069f71;--lui-neutral-color:#069f71;--lui-accent-text-color:rgba(15,22,33,.8)}lui-desktoplayer-theme .lui-significant.lui-interactive:hover,lui-desktoplayer-theme :host(.lui-significant) .lui-interactive:hover{--lui-accent-color:#ffd01b;--lui-neutral-color:#ffbd09;--lui-accent-text-color:rgba(15,22,33,.8)}lui-desktoplayer-theme .lui-significant.lui-interactive:active,lui-desktoplayer-theme :host(.lui-significant) .lui-interactive:active{--lui-accent-color:#fa9d00;--lui-neutral-color:#fa9d00;--lui-accent-text-color:rgba(15,22,33,.8)}lui-desktoplayer-theme .lui-negative.lui-interactive:hover,lui-desktoplayer-theme :host(.lui-negative) .lui-interactive:hover{--lui-accent-color:#d35566;--lui-neutral-color:#cf001a;--lui-accent-text-color:rgba(15,22,33,.8)}lui-desktoplayer-theme .lui-negative.lui-interactive:active,lui-desktoplayer-theme :host(.lui-negative) .lui-interactive:active{--lui-accent-color:#a5002f;--lui-neutral-color:#a5002f;--lui-accent-text-color:rgba(15,22,33,.8)}}lui-desktoplayer-theme .lui-disabled,lui-desktoplayer-theme .lui-readonly{--lui-accent-color:rgba(45,213,201,.2);--lui-accent-text-color:rgba(15,22,33,.4);--lui-field-background-color:rgba(15,22,33,.3);--lui-field-border-color:rgba(15,22,33,.1);--lui-field-text-color:hsla(0,0%,100%,.1);--lui-field-placeholder-color:hsla(0,0%,100%,.1);--lui-text-color:hsla(0,0%,100%,.1);--lui-neutral-color:hsla(0,0%,100%,.1);--lui-subdued-text-color:hsla(0,0%,100%,.1);--lui-knob-color:#6f7379;--lui-overlay-text-color:hsla(0,0%,100%,.2)}";
        /***/
      },

      /***/
      152:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_base_lui_theme__ = __webpack_require__(9);
        /**
         * Copyright (C) 2018 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */


        var LuiContextchromelayerTheme =
        /*#__PURE__*/
        function (_WEBPACK_IMPORTED_MO2) {
          _inherits(LuiContextchromelayerTheme, _WEBPACK_IMPORTED_MO2);

          function LuiContextchromelayerTheme() {
            _classCallCheck(this, LuiContextchromelayerTheme);

            return _possibleConstructorReturn(this, _getPrototypeOf(LuiContextchromelayerTheme).apply(this, arguments));
          }

          _createClass(LuiContextchromelayerTheme, null, [{
            key: "is",
            get: function get() {
              return 'lui-contextchromelayer-theme';
            }
          }]);

          return LuiContextchromelayerTheme;
        }(__WEBPACK_IMPORTED_MODULE_0__lui_base_lui_theme__["a"
        /* default */
        ]);
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiContextchromelayerTheme;
        /***/
      },

      /***/
      153:
      /***/
      function _(module, exports) {
        module.exports = "lui-contextchromelayer-theme{--lui-background-color:#272d37;--lui-secondary-background-color:rgba(15,22,33,.7);--lui-tertiary-background-color:rgba(15,22,33,.5);--lui-tooltip-background-color:#0f1621;--lui-tooltip-text-color:#fff;--lui-field-border-color:rgba(15,22,33,.7);--lui-field-text-color:hsla(0,0%,100%,.8);--lui-field-placeholder-color:hsla(0,0%,100%,.6);--lui-field-selection-text-color:inherit;--lui-neutral-color:hsla(0,0%,100%,.6);--lui-overlay-background-color:#0f1621}lui-contextchromelayer-theme .lui-focus{--lui-field-border-color:#0f1621}lui-contextchromelayer-theme :focus{--lui-overlay-background-color:#272d37}@media (hover:hover){lui-contextchromelayer-theme .lui-interactive:focus-visible{box-shadow:0 0 0 2px rgba(118,227,220,.2)}}lui-contextchromelayer-theme .lui-disabled,lui-contextchromelayer-theme .lui-readonly{--lui-field-placeholder-color:rgba(15,22,33,.1);--lui-text-color:rgba(15,22,33,.6);--lui-neutral-color:rgba(15,22,33,.8)}";
        /***/
      },

      /***/
      154:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_base_lui_theme__ = __webpack_require__(9);
        /**
         * Copyright (C) 2018 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */


        var LuiCanvaslayerTheme =
        /*#__PURE__*/
        function (_WEBPACK_IMPORTED_MO3) {
          _inherits(LuiCanvaslayerTheme, _WEBPACK_IMPORTED_MO3);

          function LuiCanvaslayerTheme() {
            _classCallCheck(this, LuiCanvaslayerTheme);

            return _possibleConstructorReturn(this, _getPrototypeOf(LuiCanvaslayerTheme).apply(this, arguments));
          }

          _createClass(LuiCanvaslayerTheme, null, [{
            key: "is",
            get: function get() {
              return 'lui-canvaslayer-theme';
            }
          }]);

          return LuiCanvaslayerTheme;
        }(__WEBPACK_IMPORTED_MODULE_0__lui_base_lui_theme__["a"
        /* default */
        ]);
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiCanvaslayerTheme;
        /***/
      },

      /***/
      155:
      /***/
      function _(module, exports) {
        module.exports = "lui-canvaslayer-theme{--lui-background-color:#3f454d;--lui-secondary-background-color:rgba(15,22,33,.4);--lui-tertiary-background-color:rgba(15,22,33,.3);--lui-headline-text-color:var(--lui-text-color)}lui-canvaslayer-theme .lui-disabled,lui-canvaslayer-theme .lui-readonly{--lui-text-color:rgba(15,22,33,.4);--lui-neutral-color:rgba(15,22,33,.4)}";
        /***/
      },

      /***/
      156:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_base_lui_theme__ = __webpack_require__(9);
        /**
         * Copyright (C) 2018 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */


        var LuiContentchromelayerTheme =
        /*#__PURE__*/
        function (_WEBPACK_IMPORTED_MO4) {
          _inherits(LuiContentchromelayerTheme, _WEBPACK_IMPORTED_MO4);

          function LuiContentchromelayerTheme() {
            _classCallCheck(this, LuiContentchromelayerTheme);

            return _possibleConstructorReturn(this, _getPrototypeOf(LuiContentchromelayerTheme).apply(this, arguments));
          }

          _createClass(LuiContentchromelayerTheme, null, [{
            key: "is",
            get: function get() {
              return 'lui-contentchromelayer-theme';
            }
          }, {
            key: "test",
            get: function get() {}
          }]);

          return LuiContentchromelayerTheme;
        }(__WEBPACK_IMPORTED_MODULE_0__lui_base_lui_theme__["a"
        /* default */
        ]);
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiContentchromelayerTheme;
        /***/
      },

      /***/
      157:
      /***/
      function _(module, exports) {
        module.exports = "lui-contentchromelayer-theme{--lui-background-color:#f3f3f4;--lui-secondary-background-color:rgba(15,22,33,.05);--lui-tertiary-background-color:rgba(15,22,33,.025);--lui-text-color:rgba(15,22,33,.8);--lui-headline-text-color:rgba(15,22,33,.8);--lui-subdued-text-color:rgba(15,22,33,.6);--lui-accent-background-color:rgba(0,182,178,.15);--lui-accent-color:#00b6b2;--lui-accent-text-color:hsla(0,0%,100%,.9);--lui-neutral-color:rgba(15,22,33,.4);--lui-field-background-color:rgba(15,22,33,.02);--lui-field-border-color:rgba(15,22,33,.25);--lui-field-text-color:rgba(15,22,33,.8);--lui-field-placeholder-color:rgba(15,22,33,.6);--lui-field-selection-background-color:rgba(0,182,178,.2);--lui-field-selection-text-color:inherit;--lui-field-caret-color:#00b6b2;--lui-focus-ring-color:rgba(0,182,178,.2);--lui-logo-color:rgba(15,22,33,.8);--lui-logo-missing-piece-color:#00b6b2;--lui-overlay-background-color:#fff;--lui-overlay-text-color:rgba(15,22,33,.8)}lui-contentchromelayer-theme .lui-selected{--lui-overlay-text-color:#0f1621}lui-contentchromelayer-theme[white]{--lui-background-color:#fff;--lui-secondary-background-color:#f3f3f4;--lui-overlay-background-color:#f3f3f4}lui-contentchromelayer-theme :focus{--lui-overlay-background-color:#dbdcdd}@media (hover:hover){lui-contentchromelayer-theme .lui-interactive:hover{--lui-accent-color:#2dd5c9;--lui-accent-text-color:#fff;--lui-subdued-text-color:rgba(15,22,33,.7);--lui-neutral-color:rgba(15,22,33,.3)}lui-contentchromelayer-theme .lui-interactive:active{--lui-accent-color:#00908a;--lui-subdued-text-color:rgba(15,22,33,.3);--lui-neutral-color:rgba(15,22,33,.2)}}lui-contentchromelayer-theme .lui-focus{--lui-field-text-color:#0f1621;--lui-field-border-color:rgba(15,22,33,.6);--lui-field-background-color:rgba(15,22,33,.04)}lui-contentchromelayer-theme .lui-negative,lui-contentchromelayer-theme .lui-positive,lui-contentchromelayer-theme .lui-significant{--lui-accent-text-color:#fff}lui-contentchromelayer-theme .lui-negative.lui-focus,lui-contentchromelayer-theme .lui-positive.lui-focus,lui-contentchromelayer-theme .lui-significant.lui-focus{--lui-field-text-color:#fff}@media (hover:hover){lui-contentchromelayer-theme .lui-negative.lui-interactive:active,lui-contentchromelayer-theme .lui-negative.lui-interactive:hover,lui-contentchromelayer-theme .lui-positive.lui-interactive:active,lui-contentchromelayer-theme .lui-positive.lui-interactive:hover,lui-contentchromelayer-theme .lui-significant.lui-interactive:active,lui-contentchromelayer-theme .lui-significant.lui-interactive:hover,lui-contentchromelayer-theme :host(.lui-negative) .lui-interactive:active,lui-contentchromelayer-theme :host(.lui-negative) .lui-interactive:hover,lui-contentchromelayer-theme :host(.lui-positive) .lui-interactive:active,lui-contentchromelayer-theme :host(.lui-positive) .lui-interactive:hover,lui-contentchromelayer-theme :host(.lui-significant) .lui-interactive:active,lui-contentchromelayer-theme :host(.lui-significant) .lui-interactive:hover{--lui-accent-text-color:#fff}}lui-contentchromelayer-theme .lui-disabled,lui-contentchromelayer-theme .lui-readonly{--lui-accent-color:rgba(0,182,178,.2);--lui-accent-text-color:hsla(0,0%,100%,.6);--lui-text-color:rgba(15,22,33,.2);--lui-field-background-color:rgba(15,22,33,.1);--lui-field-border-color:rgba(15,22,33,.1);--lui-field-text-color:rgba(15,22,33,.1);--lui-field-placeholder-color:rgba(15,22,33,.1);--lui-neutral-color:rgba(15,22,33,.1);--lui-subdued-text-color:rgba(15,22,33,.1);--lui-knob-color:#cfd0d3;--lui-overlay-text-color:rgba(15,22,33,.2)}";
        /***/
      },

      /***/
      158:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_base_lui_theme__ = __webpack_require__(9);
        /**
         * Copyright (C) 2018 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */


        var LuiBrandmembranelayerTheme =
        /*#__PURE__*/
        function (_WEBPACK_IMPORTED_MO5) {
          _inherits(LuiBrandmembranelayerTheme, _WEBPACK_IMPORTED_MO5);

          function LuiBrandmembranelayerTheme() {
            _classCallCheck(this, LuiBrandmembranelayerTheme);

            return _possibleConstructorReturn(this, _getPrototypeOf(LuiBrandmembranelayerTheme).apply(this, arguments));
          }

          _createClass(LuiBrandmembranelayerTheme, null, [{
            key: "is",
            get: function get() {
              return 'lui-brandmembranelayer-theme';
            }
          }]);

          return LuiBrandmembranelayerTheme;
        }(__WEBPACK_IMPORTED_MODULE_0__lui_base_lui_theme__["a"
        /* default */
        ]);
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiBrandmembranelayerTheme;
        /***/
      },

      /***/
      159:
      /***/
      function _(module, exports) {
        module.exports = "lui-brandmembranelayer-theme{--lui-background-color:#2dd5c9;--lui-secondary-background-color:rgba(15,22,33,.1);--lui-tertiary-background-color:rgba(15,22,33,.08);--lui-text-color:#fff;--lui-subdued-text-color:hsla(0,0%,100%,.7);--lui-headline-text-color:#fff;--lui-neutral-color:rgba(15,22,33,.4);--lui-accent-background-color:hsla(0,0%,100%,.15);--lui-accent-color:#fff;--lui-accent-text-color:#00b6b2;--lui-field-background-color:rgba(15,22,33,.3);--lui-field-border-color:rgba(0,111,102,.7);--lui-field-text-color:hsla(0,0%,100%,.8);--lui-field-placeholder-color:hsla(0,0%,100%,.6);--lui-field-selection-text-color:inherit;--lui-field-caret-color:#2dd5c9;--lui-focus-ring-color:hsla(0,0%,100%,.4);--lui-logo-color:#fff;--lui-logo-missing-piece-color:#fff;--lui-overlay-background-color:#fff;--lui-overlay-text-color:rgba(15,22,33,.8)}lui-brandmembranelayer-theme .lui-positive{--lui-text-color:#069f71;--lui-neutral-color:#069f71}lui-brandmembranelayer-theme .lui-selected{--lui-overlay-text-color:#0f1621}lui-brandmembranelayer-theme :focus{--lui-overlay-background-color:#e7e8e9}@media (hover:hover){lui-brandmembranelayer-theme .lui-interactive:hover{--lui-accent-color:hsla(0,0%,100%,.85);--lui-accent-text-color:#00b6b2;--lui-subdued-text-color:hsla(0,0%,100%,.85)}lui-brandmembranelayer-theme .lui-interactive:active{--lui-accent-color:rgba(15,22,33,.2);--lui-accent-text-color:hsla(0,0%,100%,.4);--lui-subdued-text-color:rgba(15,22,33,.2)}}lui-brandmembranelayer-theme .lui-focus{--lui-field-background-color:rgba(15,22,33,.15);--lui-field-text-color:hsla(0,0%,100%,.9)}lui-brandmembranelayer-theme .lui-disabled,lui-brandmembranelayer-theme .lui-readonly{--lui-accent-color:hsla(0,0%,100%,.4);--lui-accent-text-color:#2dd5c9;--lui-field-background-color:rgba(15,22,33,.3);--lui-field-border-color:rgba(15,22,33,.1);--lui-field-text-color:hsla(0,0%,100%,.2);--lui-field-placeholder-color:hsla(0,0%,100%,.2);--lui-subdued-text-color:hsla(0,0%,100%,.4);--lui-knob-color:#00b6b2}";
        /***/
      },

      /***/
      2:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        var LuiElement =
        /*#__PURE__*/
        function (_HTMLElement) {
          _inherits(LuiElement, _HTMLElement);

          function LuiElement() {
            _classCallCheck(this, LuiElement);

            return _possibleConstructorReturn(this, _getPrototypeOf(LuiElement).apply(this, arguments));
          }

          _createClass(LuiElement, null, [{
            key: "cssClass",
            value: function cssClass() {
              return this.dasherize(this.name);
            }
          }, {
            key: "modifierCssClass",
            value: function modifierCssClass(name) {
              return this.cssClass() + '-' + name;
            }
          }, {
            key: "dasherize",
            value: function dasherize(name) {
              return name.replace(/[A-Z]+/g, function (c, p) {
                return (p > 0 ? '-' : '') + c.toLowerCase();
              });
            }
          }, {
            key: "is",
            get: function get() {
              return '';
            }
          }]);

          return LuiElement;
        }(_wrapNativeSuper(HTMLElement));
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiElement;
        /***/
      },

      /***/
      9:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony import */

        var __WEBPACK_IMPORTED_MODULE_0__lui_element__ = __webpack_require__(2);
        /**
         * Copyright (C) 2018 HERE Global B.V. and its affiliate(s).
         * All rights reserved.
         *
         * This software and other materials contain proprietary information
         * controlled by HERE and are protected by applicable copyright legislation.
         * Any use and utilization of this software and other materials and
         * disclosure to any third parties is conditional upon having a separate
         * agreement with HERE for the access, use, utilization or disclosure of this
         * software. In the absence of such agreement, the use of the software is not
         * allowed.
         */


        var LuiTheme =
        /*#__PURE__*/
        function (_WEBPACK_IMPORTED_MO6) {
          _inherits(LuiTheme, _WEBPACK_IMPORTED_MO6);

          _createClass(LuiTheme, null, [{
            key: "_generateThemeCss",
            value: function _generateThemeCss() {
              var css = document.getElementById("".concat(this.is, "-style")).innerText;
              css = css.replace(/($|\s|,|\})lui-\w+(-theme)?\{.+?\}/g, '$1');
              css = css.replace(/lui-\w+(-theme)? /g, '');
              return css;
            }
          }, {
            key: "themeName",
            get: function get() {
              return this.is.replace(/^lui-|-theme$/g, '').toLowerCase();
            }
          }, {
            key: "themeCss",
            get: function get() {
              if (!this._themeCss) this._themeCss = this._generateThemeCss();
              return this._themeCss;
            }
          }]);

          function LuiTheme() {
            var _this;

            _classCallCheck(this, LuiTheme);

            _this = _possibleConstructorReturn(this, _getPrototypeOf(LuiTheme).call(this));
            var name = _this.constructor.themeName;
            var themes = window.lui.themes;

            if (!themes[name]) {
              themes[name] = _this.constructor;
            }

            var themeCss = window.lui.themeCss;

            if (!themeCss[name]) {
              themeCss[name] = _this.constructor.themeCss;
            }

            return _this;
          }

          _createClass(LuiTheme, [{
            key: "connectedCallback",
            value: function connectedCallback() {
              var styles = window.getComputedStyle(this);
              var themeCascadeParent = styles.getPropertyValue('--lui-theme-cascade');
              var themeCascade = themeCascadeParent + '/' + this.constructor.themeName;
              this.style.setProperty('--lui-theme-cascade', themeCascade);
              var themeCss = window.lui.themeCss;

              if (!themeCss[themeCascade]) {
                var parentThemeCss = themeCss[themeCascadeParent];
                themeCss[themeCascade] = parentThemeCss + this.constructor.themeCss;
              }
            }
          }]);

          return LuiTheme;
        }(__WEBPACK_IMPORTED_MODULE_0__lui_element__["a"
        /* default */
        ]);
        /* harmony export (immutable) */


        __webpack_exports__["a"] = LuiTheme;
        /***/
      }
      /******/

    })
  );
});